
























































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { FormItem, Input, Option, Select } from 'element-ui';

import LocationUpsertModal from '@/components/location/LocationUpsertModal.vue';

// Mixins
import locations from '@/mixins/locationOptions.ts';

// types
import {
  CustomerLocationFields,
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  TransportationCargoTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    LocationUpsertModal,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class FreightDeliveryInformation extends Mixins(locations) {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;

  private isModalOpen = false;

  private setModalOpen(value: boolean) {
    this.isModalOpen = value;
  }

  get customerOrganization() {
    return this.document.shipment?.customerOrganization;
  }

  get deliveryRemarks() {
    return this.value.deliveryRemarks;
  }

  set deliveryRemarks(data) {
    this.$emit('input', { ...this.value, deliveryRemarks: data });
  }

  get freightDeliveryAddress() {
    return this.value.freightDeliveryAddress;
  }

  set freightDeliveryAddress(data) {
    this.$emit('input', { ...this.value, freightDeliveryAddress: data });
  }

  get freightDeliveryContact() {
    return this.value.freightDeliveryContact;
  }

  set freightDeliveryContact(data) {
    this.$emit('input', { ...this.value, freightDeliveryContact: data });
  }

  private emitFreightDeliveryAddress(freightDeliveryAddress: string) {
    this.$emit('input', {
      ...this.value,
      freightDeliveryAddress
    });
  }

  // handle se selection to trigger creation
  private handleSelect(freightDeliveryAddress: string | null) {
    if (freightDeliveryAddress === 'new') {
      this.setModalOpen(true);
    } else {
      this.emitFreightDeliveryAddress(freightDeliveryAddress);
    }
  }

  public handleCreation(newCustomerLocation: CustomerLocationFields) {
    // on creation of new location, add new location to select option and emit the value
    this.customerLocationOptions.push(this.formatCustomerLocationOptions(newCustomerLocation));
    this.emitFreightDeliveryAddress(this.combineAddress(newCustomerLocation));
  }
}
